var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-text-input',{attrs:{"label":_vm.$t('integrations.fields.reference'),"readonly":true},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})}
var staticRenderFns = []

export { render, staticRenderFns }